import React, { lazy, Suspense } from "react"
import PropTypes from "prop-types"
import { Loading } from "../../../../shared/shared.ui.loading"

const Niches = lazy(() =>
  import("../TopicNiches").then(module => ({ default: module.Niches }))
)

const ContextTab = lazy(() =>
  import("../TopicContext").then(module => ({ default: module.ContextTab }))
)

// Read-only niches drill-in for a promoted category (N1).
const PromotedNiches = lazy(() =>
  import("../PromotedCategory/PromotedNiches").then(module => ({
    default: module.PromotedNiches
  }))
)

export const ContextOrNichesWrapper = ({
  topicId,
  match,
  history,
  location,
  isReadOnly,
  excludeContextId,
  topicName,
  topicCategory,
  topicCountry
}) => {
  const contextId = match.params.contextId
  const searchParams = new URLSearchParams(location?.search || "")
  const contextName = searchParams.get("contextName")
  const formattedTopicId = `topic.${topicId}`

  if (contextId) {
    // A promoted category inherits its parent's niches and shows them read-only.
    if (isReadOnly) {
      return (
        <Suspense fallback={<Loading />}>
          <PromotedNiches
            contextId={contextId}
            contextName={contextName}
            onBack={() => history.push(`/topics/edit/${topicId}/context`)}
          />
        </Suspense>
      )
    }

    return (
      <Suspense fallback={<Loading />}>
        <Niches
          topicId={formattedTopicId}
          contextId={contextId}
          contextName={contextName}
          history={history}
          topicName={topicName}
          topicCategory={topicCategory}
          topicCountry={topicCountry}
        />
      </Suspense>
    )
  }

  return (
    <Suspense fallback={<Loading />}>
      <ContextTab
        topicId={formattedTopicId}
        isReadOnly={isReadOnly}
        excludeContextId={excludeContextId}
      />
    </Suspense>
  )
}

ContextOrNichesWrapper.propTypes = {
  topicId: PropTypes.string.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  excludeContextId: PropTypes.string,
  topicName: PropTypes.string,
  topicCategory: PropTypes.string,
  topicCountry: PropTypes.string
}

ContextOrNichesWrapper.defaultProps = {
  isReadOnly: false
}
